import { Box, Button } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import SvgToIcon from "../../icons/SvgToIcon";

export default function ToggleButton({
  children,
  iconSVG,
  onClick,
  selected,
  disabled,
}) {
  const colors = useColors();
  const hasIcon = Boolean(iconSVG);
  return (
    <Button
      variant="text"
      onClick={onClick}
      disabled={disabled}
      disableRipple
      disableFocusRipple
      disableElevation
      sx={{
        width: "max-content",
        minWidth: 0,
        textTransform: "none",
        fontSize: "12px",
        fontWeight: selected ? 500 : 400,
        height: "28px",
        borderRadius: "8px",
        padding: 0,
        paddingX: hasIcon ? "8px" : "12px",
        color: selected ? colors.text_selected : colors.text_secondary,
        backgroundColor: selected ? colors.primary_8percent : null,
        "&:hover": {
          backgroundColor: selected ? colors.primary_8percent : null,
        },
        "&:disabled": {
          backgroundColor: null,
          color: colors.text_disabled,
        },
      }}
    >
      <Box display="flex" gap={0.5} alignItems="center">
        {hasIcon && (
          <SvgToIcon
            IconLogo={iconSVG}
            width="20px"
            height="20px"
            style={{
              color: selected ? colors.text_selected : colors.text_secondary,
            }}
          />
        )}
        <Box display="flex" alignItems="center">
          {children}
        </Box>
      </Box>
    </Button>
  );
}
